import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import './Events.css';
import NewsletterBanner from '../../components/Banner/NewsletterBanner';

import { HiOutlineArrowRight } from 'react-icons/hi2';

const events = [
    {
        id: 1,
        date: 'Jan 12',
        imageUrl: 'https://www.eventswow.com/wp-content/uploads/2023/04/Natural-Products-Expo-West-2023-scaled.jpg',
        title: 'Natural Products Expo West',
        address: '800 W. Katella Avenue Anaheim, CA 92802',
        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
        eventPageUrl: 'https://www.expowest.com/en/home.html'
    },
    {
        id: 2,
        date: 'Mar 18',
        imageUrl: 'https://dcat.org/wp-content/uploads/2021/05/DCAT_Facebook.png',
        title: 'DCAT 2024 New York City',
        address: '1335 Avenue of the Americas, USA 10019',
        description: 'We will be attending DCAT in New York City in 2024. Contact us to schedule a meeting.',
        eventPageUrl: 'https://dcatweek.org/'
    },
    {
        id: 3,
        date: 'Oct 8',
        imageUrl: 'https://lp.comecer.com/hs-fs/hubfs/2024-Logo-CPHI-Milan.png?width=1698&height=802&name=2024-Logo-CPHI-Milan.png',
        title: 'CPHI Milan',
        address: 'Strada Statale Sempione, 28, 20017 Rho MI, Italy',
        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
        eventPageUrl: 'https://europe.cphi.com/europe/en/home.html'
    },
];

const Events = () => {
    return (
        <div className='main-container'>
            <Helmet>
                <title>Join Pharm-Rx at Our Upcoming Events</title>
                <meta name="description" content="Meet Pharm-Rx at key industry events. Join us for the latest in pharma, nutraceuticals, and food ingredients." />
            </Helmet>
            <div className='events-font-wrapper'>
                <div className="events-page-container">
                    <div className="events-heading-container">
                        <h2 className="events-heading">Upcoming Events</h2>
                    </div>
                    <div className="events-paragraph-container">
                        <p className="events-paragraph">
                            Join us at our upcoming events to network with professionals, learn about the latest advancements in our field, and stay informed on the newest trends and breakthroughs in the industry.
                        </p>
                    </div>

                    <div className='events-top-border'></div>

                    <div className="events-container">
                        {events.map(event => (
                            <div key={event.id} className="event-card">
                                <div className="card-left">
                                    <div className="date-container">
                                        <span className="event-month">{event.date.split(' ')[0]}</span>
                                        <span className="event-day">{event.date.split(' ')[1]}</span>
                                    </div>
                                    <img src={event.imageUrl} alt={event.title} className="event-image" />
                                </div>
                                <div className="card-right">
                                    <h2>{event.title}</h2>
                                    <p className="event-address">{event.address}</p>
                                    <p className="event-description">{event.description}</p>
                                    <Link to={event.eventPageUrl} target="_blank" rel="noopener noreferrer" className="event-link-button">View Event Details <HiOutlineArrowRight /></Link>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <div className='full-width-banner'>
                <NewsletterBanner
                    heading="Stay Informed on Future Events"
                    paragraph="Subscribe to our newsletter for exclusive updates on events, new products, and industry insights."
                />
            </div>
        </div>
    );
};

export default Events;
